import { PiBuildings } from "react-icons/pi";

import InfoTooltip from "@/components/InfoTooltip";
import Typography from "@/components/Typography";
import { moneyCentsFormatter } from "@/utils/moneyFormat";

import { QuotasCardProps } from "./types";

const QuotasCard = ({
  consortium_name,
  quantity,
  initial_investment,
  dividend_accumulated,
  total_value,
  spe_status,
  construction_appreciation = 0,
  ipca_appreciation = 0,
}: QuotasCardProps) => {
  return (
    <div className="grid w-full grid-cols-1 gap-x-6 gap-y-4 rounded-3xl bg-white px-6 py-4 min-[321px]:grid-cols-2 lg:flex lg:flex-wrap lg:gap-0">
      <section className="flex items-center gap-4 lg:flex-1 lg:border-r lg:border-grey200">
        <div className="flex h-10 min-w-10 items-center justify-center rounded-full bg-primary300">
          <PiBuildings className="text-2xl text-white" />
        </div>
        <div className="flex flex-col">
          <Typography variant="overline" color="grey500" className="uppercase">
            SPE
          </Typography>
          <Typography variant="pLarge" color="black" className="font-semibold uppercase">
            {consortium_name}
          </Typography>
        </div>
      </section>
      <section className="flex flex-col justify-center lg:flex-1 lg:border-r lg:border-grey200 lg:px-6">
        <Typography variant="overline" color="grey500" className="uppercase">
          qtd de cotas
        </Typography>
        <Typography variant="pLarge" color="black" className="font-semibold uppercase">
          {quantity}
        </Typography>
      </section>
      <section className="flex flex-col lg:flex-1 lg:border-r lg:border-grey200 lg:px-6">
        <Typography variant="overline" color="grey500" className="uppercase">
          posição
        </Typography>
        <Typography variant="pLarge" color="black" className="font-semibold uppercase">
          {moneyCentsFormatter(initial_investment)}
        </Typography>
      </section>
      <section className="flex flex-col lg:flex-1 lg:border-r lg:border-grey200 lg:px-6">
        <div className="flex items-center gap-2">
          <Typography variant="overline" color="grey500" className="uppercase">
            valor atual
          </Typography>
          <InfoTooltip
            constructionAppreciation={construction_appreciation}
            ipcaAppreciation={ipca_appreciation}
            initialInvestment={initial_investment}
          />
        </div>
        <Typography variant="pLarge" color="success300" className="font-semibold uppercase">
          {moneyCentsFormatter(total_value)}
        </Typography>
      </section>
      <section className="flex flex-col justify-center lg:flex-1 lg:border-r lg:border-grey200 lg:px-6">
        <Typography variant="overline" color="grey500" className="uppercase">
          proventos acumulados
        </Typography>
        <Typography variant="pLarge" color="black" className="font-semibold uppercase">
          {moneyCentsFormatter(dividend_accumulated)}
        </Typography>
      </section>
      <section className="flex flex-col justify-center lg:flex-1 lg:px-6">
        <Typography variant="overline" color="grey500" className="uppercase">
          Status SPE
        </Typography>
        <Typography
          variant="pLarge"
          color="primary300"
          className="whitespace-nowrap font-semibold uppercase"
        >
          {spe_status}
        </Typography>
      </section>
    </div>
  );
};

export default QuotasCard;
